<template>
  <v-container text-center>
    <v-row
      align-content="center"
      justify="center"
      class="call-to-action"
    >
    <v-col :cols="12" :sm="6" class="center-items">
      <h1 class="display">Busca los socios que necesitas en tu negocio</h1>
      <h2 class="mt-7 title font-weight-regular">
        En
        <span class="text-secondary-color font-weight-bold">FlowLemon</span> encontrarás personas de diferentes perfiles profesionales,
        <br />podrás elegir la que mejor se adapte a ti.
      </h2>
      <!--<v-btn
        rounded
        large
        color="#EE9D32"
        width="10rem"
        class="mt-7 white--text"
        style="align-self:center;"
        @click="test"
      >Buscar</v-btn>-->
      <v-btn
        rounded
        large
        color="#EE9D32"
        width="10rem"
        class="mt-7 white--text"
        style="align-self:center;"
        dark
        @click.stop="dialog = true"
      >Pre-Registrate</v-btn>
    </v-col>

    <v-col :cols="12" :sm="6" class="d-none d-md-flex">
      <v-img :src="require('@/assets/Foto-Home-FL.jpg')" eager max-height="25rem" ></v-img>
    </v-col>
      
    </v-row>

    <v-row>
      <v-col :sm="12" :xs="12">
      <v-icon color="black" class="mt-1">mdi-arrow-down</v-icon>
    </v-col>
    </v-row>
    

    <v-row class="mt-12">
      <v-row style="justify-content: center;">
        <h3 class="display-1">Descubre algunas cosas que te ofrece FlowLemon</h3>
      </v-row>

      <v-row>
        <v-col class="feature" v-for="(feature, i) in features" :key="i">
          <v-img :src="feature.image_url" max-width="4rem" max-height="4rem"></v-img>
          <p v-html="feature.description"></p>
        </v-col>
      </v-row>
    </v-row>

    <div class="promotion full-width" style="margin-bottom: 1rem;" v-html="call_to_action_free"></div>

    <v-footer absolute app color="transparent" inset>
      <div>
        <v-btn text icon href="https://www.instagram.com/flowlemon.bcn/">
          <v-icon style="margin-right: 0.5rem;">mdi-instagram</v-icon>
        </v-btn>
        <v-btn text icon href="https://twitter.com/flow_lemon">
          <v-icon style="margin-right: 0.5rem;">mdi-twitter</v-icon>
        </v-btn>
        <v-btn text icon href="https://www.facebook.com/FlowLemonSpain/">
          <v-icon style="margin-right: 0.5rem;">mdi-facebook-box</v-icon>
        </v-btn>
        
      </div>
      <v-spacer></v-spacer>
      <div class="copyright">FlowLemon &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>

    <!-- Dialogs -->
    <!-- Register -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <Register
          :cannot_cancel_registration="false"
          @registration_canceled="dialog=false"
          @registration_finished="dialog=false"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Register from "@/modules/partners/components/Register.vue";

export default {
  components: {
    Register
  },
  data: () => ({
    dialog: false,
    features: [
      {
        image_url: require("@/assets/icons/handshake.svg"),
        description: `Te ayudamos a encontrar el <span class="keyword">socio</span> 
                      perfecto para ti y tu negocio. ¡Llegó la plataforma que conecta socios!
                      <span class="coming-soon">Disponible el 15/11/2019</span>`
      },
      {
        image_url: require("@/assets/icons/people_network.svg"),
        description: `<span class="keyword"> Publica tu proyecto</span>  en Flowlemon y dar a conocerlo a inversores,
         futuros socios o a quien tu quieras! <span class="coming-soon">Coming super soon</span>`
      },
      {
        image_url: require("@/assets/icons/currency.svg"),
        description: `Te facilitamos una <span class="keyword">red de freelances</span> y empresas por si necesitas ayuda en
                     algún tema. ¡Al alcance de tu mano! <span class="coming-soon">Coming soon</span>`
      }
    ],
    call_to_action_free: `Aprovecha la versión Beta y pre-regístrate <span class="keyword">GRATIS</span> a FlowLemon`
  }),
  methods: {
    test() {
      this.$store.commit("setShowMenu", true);
    }
  }
};
</script>

<style>
.display {
  font-size: 2rem !important;
  font-weight: 700;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  font-family: "Roboto", sans-serif !important;
  color: #3c4858;
}

.call-to-action {
  height: 80vh;
  margin-top: -1rem;
}

.text-secondary-color {
  color: #224177;
}

.feature {
  min-width: 20rem;
  margin: 1rem;
  display: flex;
}

.feature > p {
  text-align: justify;
  padding-left: 1rem;
}

.keyword {
  color: #ee9d32;
  font-weight: 500;
}

.coming-soon {
  font-weight: 500;
  font-size: small;
  color: #214177;
}

.promotion {
  background: rgba(238, 157, 50, 0.1);
  margin-left: -12px;
  margin-right: -12px;
  padding: 2rem 0px;
}

.copyright {
  font-size: small;
}

.full-width {
  /* Warning this only works if the parent container is centered */
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}


@media (min-width: 1264px) {
  .center-items{
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
}

</style>
